import React, { useEffect, useState } from 'react';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import CKEditor from 'ckeditor4-react';
import { NotificationManager } from 'react-notifications';
import { Fecha, formatBytes, iconos, addAttachment, sendReplyMail } from '../../funciones/EmailFunction';

CKEditor.editorUrl = 'ckeditor/ckeditor.js';

const ReplyEmail = (props) => {
    const [destEmail, setDestEmail] = useState("");
    const [asunto, setAsunto] = useState(`Re: ${props.contenido.Title}`);
    const [control, setControl] = useState(false);
    const [boton1, setBoton1] = useState({ icon: "fa fa-reply", text: "Responder", disabled: false });
    const [boton2, setBoton2] = useState({ icon: "fa fa-paperclip", text: "Adjuntar Archivo" });
    const [destinatarios, setDestinatarios] = useState([]);
    const [tam, setTam] = useState(0);
    const [attFileName, setAttFileName] = useState([]);
    const [contentState, setContentState] = useState();
    const [openModalConfirm, setOpenModalConfirm] = useState(false);

    useEffect(() => {
        let partes = (props.contenido.Sender).split("<");
        let fecha = Fecha(props.contenido.Date);
        let {parte1, parte2 } = "";

        if (partes.length > 1){
            parte1 = partes[0];
            parte2 = partes[1].slice(0, -1);
        }else{
            parte1 = partes[0];
        }

        setContentState (`<div>
                            <br/>
                            <div align="center">-******-</div>
                            <div>
                                Mensaje de <strong>${parte1}</strong><span style="font-size: 12px; color: #b41806">${parte2} - (<span>${fecha}</span>)</span>:
                            </div>
                            <div style="margin-left: 10px; border-left: 1px solid #9A9A9A">${props.Mess}</div
                          </div>`
        )

        let partesM = (props.Mess).split(" ");
        let contentP = [];
        partesM.map(parte => {
            let part1 = parte.split("<")
            part1.map(subparte => {
                let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
                if (expReg.test(subparte) === true) contentP.push(subparte)
            })
        })

        let partesCorreo = parte2.split("@");

        if(contentP.length > 0) {
            let contenidoE = [];

            if (partesCorreo[0] !== "noreply" && partesCorreo[0] !== "noresponder") contenidoE.push({ tipo:"D", email: parte2, color: "6c7c9c"})
            
            contentP.map(email => {
                contenidoE.push({ tipo:"D", email: email.toLowerCase(), color: "59ac3d"})
            })

            NotificationManager.info(`Se han añadido automaticamente ${contentP.length} correo(s) en la sección de destinatarios`);
            setDestinatarios(contenidoE);
        }else{
            if (partesCorreo[0] !== "noreply" && partesCorreo[0] !== "noresponder") setDestinatarios([{ tipo:"D", email: parte2, color: "6c7c9c"}])
        }
    }, []);

    let styles2 = {
        paddingRight: 15,
        cursor: "pointer",
        fontSize: 16,
        color: "f6a72f"
    }

    const configuraciones = {
        toolbar: [
            [ 'Font', 'FontSize', '-', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo', '-', 'Bold', 'Italic', 'Underline', '-', 'TextColor', 'BGColor', '-', 'Link', 'Maximize' ],
        ],
        height: "21vh",
        removePlugins: 'elementspath',
        /* removePlugins: 'resize, elementspath', */
    }

    let cambiaHtml = (e) => {
        setContentState(e.editor.getData())
    }

    let tipoDest = (tipo) => {
        switch (tipo) {
            case "D": return null
            case "C": return "CC: "
            case "CO": return "CCO: "
        }
    }
    
    let para = () => {
        if (destinatarios.length === 0 ) return (
            <div className="text-muted">Sin Destinatarios</div>
        )
        
        let borrar = (email) => {
            let contenido = destinatarios;

            for (let i in destinatarios){
                if (destinatarios[i].email === email) contenido.splice(i, 1)
            }

            setDestinatarios(contenido)
            setControl(!control)
        }

        return (
            destinatarios.map(option => (
                <span key = {(Math.random() * 999999) + 1} className="tagsinput" style={{backgroundColor: option.color}}>{tipoDest(option.tipo)}{option.email} <i className="fa fa-times" onClick={() => {borrar(option.email)}} title="Eliminar" style={{cursor: "pointer"}}></i></span>
            ))
        )
    }

    let addDestinatario = (e) => {
        if (e.which === 13){
            let string = (e.target.value).trim();
            if (string === "") return null;

            const resultado = destinatarios.find( item => item.email === e.target.value );
            if (resultado === undefined){
                let contenido = destinatarios;
                let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
                (expReg.test(string) === false) ? contenido.push({ tipo:"D", email: destEmail, color: "cb0b0b"}) : contenido.push({ tipo:"D", email: destEmail, color: "6c7c9c"});
                
                setDestinatarios(contenido)
            }

            setControl(!control)
            setDestEmail("")
        }
    }

    let addOtDestinatario = (tipoD) => () => {
        let string = (destEmail).trim();
        if (string === "") return null;
        
        let contenido = destinatarios;
        let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
        (expReg.test(string) === false) ? contenido.push({ tipo: tipoD, email: destEmail, color: "cb0b0b"}) : contenido.push({ tipo: tipoD, email: destEmail, color: "6c7c9c"});
        
        setDestinatarios(contenido)
        setControl(!control)
        setDestEmail("")
    }

    let addAttState = (item) => {
        let contenido = attFileName;
        contenido.push(item)

        setTam(tam + item[2])
        setAttFileName(contenido)
        setControl(!control)
    }

    let delAttachment = (adj) => {
        let contenido = attFileName;
        let size = 0;
        for (let i in attFileName){
            if (adj === attFileName[i][3]) contenido.splice(i, 1)
            if (attFileName[i] !== undefined) size += attFileName[i][2]
        }

        let file = document.getElementById(adj);
        if (file) {
            (file.parentNode).removeChild(file);
        }
        
        setTam(size)
        setAttFileName(contenido)
        setControl(!control)
    }
    
    let adjuntos = () => {
        if (attFileName.length === 0) return (
            <div align="center" className="text-muted" style={{fontSize: 11}}>Ningún archivo</div>
        )
        
        return attFileName.map(option => (
            <div key = {(Math.random() * 999999) + 1} className="attachment-file" style={{fontSize: 10, marginTop: 4, cursor: "default"}}>
                <i className={iconos(option[1].toUpperCase(), "icono")} style={{color: iconos(option[1].toUpperCase(), "color")}}></i> {option[0]}
                <div className="text-muted" align="right">({formatBytes(option[2])}) <i className="fa fa-trash text-danger" style={{fontSize: 12, cursor: "pointer"}} onClick={() => {delAttachment(option[3])}} title="Quitar este archivo"></i></div>
            </div>
        ))
    }

    let tipos = (
        <Popover id="tipos">
            <div className="new-mail-item" onClick={addOtDestinatario("D")}>Destinatario</div>
            <div className="new-mail-item" onClick={addOtDestinatario("C")}>CC</div>
            <div className="new-mail-item" onClick={addOtDestinatario("CO")}>CCO</div>
        </Popover>
    )

    let contenidoMail = () => (
        <Row>
            <Col md={6}>
                <span className="text-muted" style={{fontSize: 10}}>Para:</span>
                <div className="input-group">
                    <input type="text" className="form-control" onChange={(e)=> {setDestEmail((e.target.value).trim())}} value={destEmail}
                    onKeyPress={ addDestinatario } title="Presiona ENTER para añadir un nuevo destinatario" placeholder="Para"/>
                    <div className="input-group-btn">
                        <OverlayTrigger trigger="focus" placement="bottom" overlay={tipos}>
                            <button className="btn btn-default" title="Agregar como" style={{height: 40}}><i className="fa fa-plus" style={{color: "005d9b"}}></i></button>
                        </OverlayTrigger>
                    </div>
                </div>
            </Col>
            <Col md={6}>
                <span className="text-muted" style={{fontSize: 10}}>Asunto:</span>
                <input type="text" className="form-control" placeholder="Asunto" value={asunto} onChange={(e) => {setAsunto(e.target.value)}}/>
            </Col>
            <Col md={12} className="custom-mt-10" style={{backgroundColor:"f2f4f8", overflowX:"hidden", overflowY: "auto", height: "8vh", padding: 5}}>
                {para()}
            </Col>
            <Col md={12} style={{padding: 6, paddingTop: 3}}>
                <div className="new-mail-body">
                    <CKEditor
                        
                        data = {contentState}
                        type = "classic"
                        onChange = {cambiaHtml} 
                        config = {configuraciones}
                    />
                </div>
            </Col>
        </Row>
    )

    let respSend = (resp) => {
        if (resp.tipo === "info") props.funcion()

        NotificationManager[resp.tipo](resp.text);
        setBoton1({icon: "fa fa-reply", text: "Responder", disabled: false})
    }

    let sendMess = () => {
        if (boton1.disabled === true) return null;

        if (destEmail === "" && destinatarios.length === 0){
            NotificationManager.error("Debes tener al menos un destinatario");
            return null;
        }

        if (contentState === "" && asunto === ""){
            setOpenModalConfirm(true)
        }else{
            /* Agregar los adjuntos */
            let adjuntos = []
            attFileName.map(file => {
                adjuntos.push(document.getElementById(file[3]))
            })

            setBoton1({icon: "fa fa-spinner fa-spin", text: "Enviando", disabled: true})
            sendReplyMail (adjuntos, props.Remitente.value, destEmail, destinatarios, asunto, contentState, (resp) => {respSend(resp)})
        }
    }

    return (
        <React.Fragment>
            <Row style={{paddingLeft: 10, paddingRight: 10}}>
                <div className="custom-alert-info" style={{backgroundColor:"fff", minHeight: 45, boxShadow:"2px 2px 4px #CCC", padding: 5}}>
                    <Row>
                        <Col md={7} xs={12}>
                        <div><i title="Volver al mensaje" onClick={()=> {props.funcion()}} className="fa fa-arrow-circle-left" style={styles2}></i> <strong>Responder Mensaje</strong></div>
                            <div className="text-muted" style={{fontSize: 12, paddingLeft: 22}}>De: <strong>{props.Remitente.label}</strong></div>
                        </Col>
                    </Row>
                </div>
            </Row>
            <Row className="custom-mt-10" style={{left: 15, right: 15, position:"absolute", backgroundColor:"fff",
                height: "57vh", overflowY: "auto", overflowX: "hidden", borderTop: "1px solid #ededed", borderBotton: "1px solid #ededed"}}>
                <Col md={9} className="custom-mt-10">
                    {contenidoMail()}
                </Col>
                <Col md={3} className="custom-mt-10" style={{paddingLeft: 0}}>
                    <div style={{backgroundColor:"f2f4f8", boxShadow:"inset 2px 2px 1px #CCC", borderRadius:"4px 4px", padding: 5}}>
                        <div align="center" style={{height: "42vh", overflowY: "auto", overflowX: "hidden"}}>
                            <button className="btn btn-default" onClick={() => {addAttachment((Math.random() * 999999) + 1, (resp) => { addAttState(resp) })}} style={{borderWidth: 0, marginBottom: 5}} title="Haz click aqui para adjuntar un archivo"><i className={boton2.icon}></i> {boton2.text}</button>
                            <div id="attachments"></div>
                            <div style={{borderTop: "1px solid #ccc", paddingTop: 5}} align="left">{adjuntos()}</div>
                        </div>
                        <div style={{fontSize: 10, paddingTop: 4, borderTop: "1px solid #ccc"}} align="right"><strong>Total ({formatBytes(tam)})</strong></div>
                    </div>
                    <div className="custom-mt-10" align="right">
                        <button className="btn btn-primary" disabled={boton1.disabled} onClick = { sendMess } style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default ReplyEmail;


// WEBPACK FOOTER //
// ./src/views/Email/ReplyEmail.jsx